export default __webpack_public_path__ + "static/media/tud_logo_rgb.8098f01b.jpg";